import * as bc from "bc-js";

import { GabaritNavigationUtil } from "../../../utils/gabarit-navigation/GabaritNavigationUtil";
import { LangueUtils } from "@oel/js-i18n";
import { en } from "./i18n/DetailsCompteBancaireADA.i18n.en";
import { fr } from "./i18n/DetailsCompteBancaireADA.i18n.fr";
import { useParams } from 'react-router';
import { useEffect } from "react";
import {ConfigurationService} from "@oel/js-configuration";
import { IdPageEnum } from "../../../utils/gabarit-navigation/IdPageEnum";

export function DetailsCompteBancaireADA() {

    const params = useParams();
    const libelles = new LangueUtils(fr, en).obtenirLibelles();

    useEffect(() => {
        document.title = ConfigurationService.getConfig("oel-is-app") === "false" ? libelles.titreOnglet : libelles.titreOngletMobile;
        GabaritNavigationUtil.afficherGabarit(IdPageEnum.DETAIL_EOP_ADA);
        bc.changerContexte("ACCOUNT_Detail");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <detail-compte-bancaire id-contexte={params.idContexte} />
        </div>
    );
}
